class CustomSearchPopup extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.openBtn = this.body.querySelector(".js-search-header--custom");
    this.searchContainer = this.body.querySelector(".site-header__search-container");
    this.searchBackground = this.body.querySelector(".predictive__screen");
    this.backBtn = this.body.querySelector(".btn-back-search--custom");
    this.clearBtn = this.body.querySelector(".btn-close-search--custom");
    this.input = this.body.querySelector('#Search');
    this.resultsHeading = this.querySelector(".search-content__products .heading");
    this.originalResultsHeading = this.resultsHeading.textContent || '';
    this.resultsContainer = this.querySelector('#SearchResults');
    this.originalResultsHTML = this.resultsContainer?.innerHTML || '';
    this.viewAllContainer = this.querySelector('#ViewAllContainer');
    this.debouncedHandleSearchInput = this.debounce(this.handleSearchInput.bind(this), 500);
  }

  connectedCallback() {
    this.setupEventListeners();
    this.initSwiper();
  }

  setupEventListeners() {
    this.clearBtn.addEventListener("click", this.clearSearchResults.bind(this));
    this.input.addEventListener('input', this.debouncedHandleSearchInput);
    
    this.openBtn?.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      this.searchContainer.appendChild(this);
      this.body.appendChild(this.searchContainer);
      this.body.classList.add('no-scroll');
      this.classList.remove('hide');
      this.searchBackground.classList.add("is-active");
      this.searchContainer.classList.add("is-active");
    });

    this.backBtn.addEventListener("click", () => {
      this.clearSearchResults();
      this.body.classList.remove('no-scroll');
      this.searchContainer.classList.remove("is-active");
      this.classList.add("hide");
      this.searchBackground.classList.remove("is-active");
    });
  }

  clearSearchResults() {
    this.input.value = '';
    this.clearBtn.classList.add('hide');
    this.resultsContainer.innerHTML = this.originalResultsHTML;
    this.resultsContainer.classList.remove('search-results');
    this.resultsHeading.textContent = this.originalResultsHeading;
    this.viewAllContainer.innerHTML = '';
  }

  debounce(fn, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  async handleSearchInput() {
    const query = this.input.value.trim();
  
    if (query.length === 0) {
      this.clearSearchResults();
      return;
    }

    this.clearBtn.classList.remove('hide');
  
    if (query.length < 2) {
      this.resultsContainer.innerHTML = '';
      this.viewAllContainer.innerHTML = '';
      return;
    }
  
    try {
      // Start both fetches in parallel
      const suggestPromise = fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`);
      const searchPromise = fetch(`/search?q=${encodeURIComponent(query)}&type=product`);
  
      // Wait for predictive results first
      const suggestResponse = await suggestPromise;
      const suggestData = await suggestResponse.json();
      const results = suggestData.resources.results.products;
      const keywords = ['series', 'edition', 'collection', 'dalstrong'];
  
      this.resultsContainer.classList.add('search-results');
      this.resultsContainer.innerHTML = results.map(product => {
        if (product.handle.includes("mystery-gift")) {
          return '';
        }
        const titleValues = product.title.split('|').map(s => s.trim());
        let seriesIndex = 1;
  
        for (let i = 0; i < titleValues.length; i++) {
          const lowerVal = titleValues[i].toLowerCase();
          if (keywords.some(keyword => lowerVal.includes(keyword))) {
            seriesIndex = i;
            break;
          }
        }
  
        const series = titleValues[seriesIndex] || '';
        const mainTitle = titleValues[0] || '';
        return `
          <div class="predictive-result">
            <a href="${product.url}">
              <img src="${product.featured_image?.url || ''}" alt="${product.title}" width="40">
              <div class="search-content__product-content-container">
                <p class="search-content__product-series">${series}</p>
                <p class="search-content__product-title">${mainTitle}</p>
                <p class="search-content__product-price">$${product.price}</p>
              </div>
            </a>
          </div>
        `;
      }).join('');

      this.resultsHeading.innerHTML = `<div class="loader"></div>`;
      this.viewAllContainer.innerHTML = '';
  
      // While predictive results are visible, now wait for the full search HTML
      const searchResponse = await searchPromise;
      const searchHtml = await searchResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(searchHtml, 'text/html');
      const countEl = doc.querySelector('#SearchResultsCount');
  
      if (countEl) {
        const match = countEl.textContent.match(/(\d+)/);
        const count = match ? match[1] : null;
  
        if (count) {
          this.resultsHeading.textContent = `${count} results`;
          this.viewAllContainer.innerHTML = `
            <a href="/search?q=${encodeURIComponent(query)}&type=product" class="predictive-view-all__link">
              View all
            </a>
          `;
        } else {
          this.viewAllContainer.innerHTML = '';
        }
      } else {
        this.viewAllContainer.innerHTML = '';
      }
  
    } catch (error) {
      console.error('Error fetching search results:', error);
      this.resultsContainer.innerHTML = '';
      this.viewAllContainer.innerHTML = '';
    }
  }  

  initSwiper() {
    const swiperElement = this.querySelector('.search-content__content .swiper');
    if (swiperElement) {
      new Swiper(swiperElement, {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    }
  }
}

customElements.define('custom-search-popup', CustomSearchPopup);